import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { ModalLocationPermissionPage } from './modal-location-permission.page';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		TranslateModule.forChild()
	],
	declarations: [
		ModalLocationPermissionPage
	]
})
export class ModalLocationPermissionPageModule { }
